import React, { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink } from "react-router-dom";
import {
  getSideBarfilesActions,
  SetTheResignActions,
  SetTheResignDelete,
  setTheoptions,
  setThecountBasedRenders,
  ////--filters
  setRegionActions,
  setZoneActions,
  setGeoLoactionStateAction,
  setDropDownRenders,
  setTheResignZone,
  setTheResignState,
  setTheResignRegion,
  setheResigndesignationStatus,
  setTheResignStateStatus,
  setTablePositionPersist

} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import correctIcons from "../../../Assets/AppComponent/icons/Group 359.svg";
import Pendingimg from "../../../Assets/AppComponent/icons/Group 145.svg";
import ResignAproval from "./ResginApproval";
import Delete from "../../AppComponent/Popup/Delete";
import Select from "react-select";
import _ from "lodash";
import EditImages from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-04 (1).svg";
import ThumbsImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-13.svg";
import BanImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-26.svg";
import useDebouncedEffect from 'use-debounced-effect';


const Resgin = () => {
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
      const TablePositionPersist = useSelector(
        (state) => state.PreviousPagePosition.TablePositionPersist
      )
    
  const UserObjectData = useSelector((state) => state.users.UserData);
  const [sno, setsno] = useState(0);
  const state = useSelector((state) => state);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [Data, setData] = useState([]);
const [dtpageindex, setdtPageindex] = useState(
    TablePositionPersist?.ResginformlistRequestedPagelist?.page == undefined
      ? 1
      : TablePositionPersist.ResginformlistRequestedPagelist.page
  );
  

const [search, setsearch] = useState(
    TablePositionPersist?.ResginformlistRequestedPagelist?.search == undefined ||
    TablePositionPersist?.ResginformlistRequestedPagelist?.search ==""
      ? ""
      : TablePositionPersist.ResginformlistRequestedPagelist.search
  ); 
   
  
  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [newpages, setNewpage] = useState(1);
  const [DeleteID, setDeleteId] = useState();
  const [DeletePopup, setDeletePopup] = useState(false);
  const [EmployeePop, setEmployeePop] = useState(false);
  const [EmployeeIDs, setEmployeeIDs] = useState();

  ///---filter for white collar--------
  const [EmpRoles, setEmplyeRole] = useState([
    {
      value: "0",
      label: "ALL",
    },
    {
      value: "1",
      label: "UDS",
    },
    {
      value: "2",
      label: "CLIENT",
    },
  ]);

  const [filterForWhite, setFilters] = useState({ white_collar:


    state.StateManagementOverallCall.Resigndesignation?.value == ""?
    "":
    state.StateManagementOverallCall.Resigndesignation?.value == 1 ?
    false:
    state.StateManagementOverallCall.Resigndesignation?.value == 0 && true


   });
  const HandleEMprole = (e) => {
    if (e != null) {
       dispatch(setheResigndesignationStatus(e))
        
      if (e.value == 1) {
        setFilters({
          ...filterForWhite,
          white_collar: true,
        });
      } else  if(e.value == 2){
        setFilters({
          ...filterForWhite,
          white_collar: false,
        });
      }
      else  {
        setFilters({
          ...filterForWhite,
          white_collar: "",
        });
        dispatch(setheResigndesignationStatus({value:"0",label:"ALL"}))

       }
    }
  };


  

  const FileterState = {
    status: state.StateManagementOverallCall.ResignStatusState?.value,
  };
  const [selectDisplay, setDisplay] = useState([]);
  const [selectVal, SetSelectval] = useState(FileterState);
  const [FState, SetStates] = useState(false);
  ////--_FIlter--------------------------
  const [Filter, SetFilter] = useState(true);

  ///--filter----------------
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState(
    state.StateManagementOverallCall.ResignRegion

  );
  const [multiselect3, setMuliselect3] = useState(
    state.StateManagementOverallCall.ResignZone

  );
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [data, setDatas] = useState({ 
    zone: state.StateManagementOverallCall.ResignZone?.value,     
    state: state.StateManagementOverallCall.ResignState?.value,
 region: state.StateManagementOverallCall.ResignRegion?.value
 });
 const [multiselect, setMuliselect] = useState([
  //  { value: "", label: "ALL" }
   state.StateManagementOverallCall.ResignState
  // state.ClientBranchIDs.StateName,
]);

const options = [
  { value:"" , label: "All" },
  { value: "pending", label: "Pending" },
  { value: "decline", label: "Decline" },
  { value: "approved", label: "Approved" },
];
const [place, SetPlace] = useState("");
  const [sel, setSelected] = useState();
  useEffect(() => {
    const payload = {
      search: search,
      page_size: 10,
      page: dtpageindex,
      selectVal: selectVal,
      data: data,
      white_collar: filterForWhite.white_collar,
    };
    dispatch(SetTheResignActions(payload));
         dispatch(
                  setTablePositionPersist({
                    data: payload,
                    pageName: "ResginformlistRequestedPagelist",
                  })
                );
                
  }, [selectVal, data, filterForWhite,dtpageindex,search]);

  useEffect(() => {
    setData(state.resignCall.ResginDatas);
  }, [state.resignCall.ResginDatas]);
  // console.log(state.resignCall.ResginDatas, "OnDutyDatas");

  ///----filter-----
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const initialDebouanceSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
};

const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);
  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: currentPage,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);
  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: currentPage,
      counts: 1, //-----only we ----get----the----selected regions , the-
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);
  useEffect(() => {
    const Datas = [];
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      objectArray.push({ value: "", label: "ALL" });

      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name.toUpperCase() });
      });
      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];
    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({ value: element.id, label: element.region_name.toUpperCase() });
      });
      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setDatas({
        ...data,
        region: selectedVal.value,
      });
      dispatch(setTheResignRegion(selectedVal));
      dispatch(setTheResignZone({ value: "", label: "ALL" }));


    }
    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setDatas({
        ...data,
        region: "",
        zone: "",
      });
      dispatch(setTheResignRegion({ value: "", label: "ALL" }));
      dispatch(setTheResignZone({ value: "", label: "ALL" }));


    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    //console.log(selectedVal ,"selected Values");
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setDatas({
        ...data,
        zone: selectedVal.value,
      });
      dispatch(setTheResignZone(selectedVal));


    }
    if (selectedVal == null) {
      setDatas({
        ...data,
        zone: "",
      });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setTheResignZone({ value: "", label: "ALL" }));


    }

  };
  const handleSelectChange = (selectedVal) => {
    console.log(selectedVal, "selectedval");
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });

      dispatch(setTheResignState(selectedVal));
      dispatch(setTheResignRegion({ value: "", label: "ALL" }));
      dispatch(setTheResignZone({ value: "", label: "ALL" }));

      
      // console.log(selectedVal, "asfad");
      setDatas({
        ...data,
        state: selectedVal.value,
        region: "",
        zone: "",
      });
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      dispatch(setTheResignState({ value: "", label: "ALL" }));
      dispatch(setTheResignRegion({ value: "", label: "ALL" }));
      dispatch(setTheResignZone({ value: "", label: "ALL" }));



      setDatas({
        ...data,
        state: "",
        zone: "",
        region: "",
      });
    }
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];
    setZone(state.ZonePart.Zone);
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({ value: element.id, label: element.zone_name.toUpperCase() });
      });
      setOptions4(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);


   ///-----State----Input Changes
   const handleInputChange = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        stateSearch: Val,
    });
  };

///---Region-----------------
const handleInputRegion = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        regionSearch: Val,
    });
};
///----Zone---Name
const handleInputZone = (Val) => {
    setSearchDebounance({
        ...SearchDebounance,
        zoneSearch: Val,
    });
};

useDebouncedEffect(
  () => {
      if (setSearchDebounance) {
          setSearched({
              ...SearchedVal,
              stateSearch: SearchDebounance.stateSearch,
              regionSearch: SearchDebounance.regionSearch,
              zoneSearch: SearchDebounance.zoneSearch,
          });
      }
  },
  500,
  [SearchDebounance]
);


  const debouncedSearch = useMemo(
    () =>
      _.debounce((e) => {
        setsearch(e);
      }, 500),
    []
  );

  // -----Search------------------------
  function tochange(e) {
    setdtPageindex(1);
    debouncedSearch(e);
   
  }

  React.useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

 


  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };
  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};
const capitalizeFirstLetter = (Letter) => {
    return Letter.charAt(0).toUpperCase() + Letter.slice(1);
  };

  const columns = useMemo(
    () => [
      {
        Header: "Tnx Id",
        accessor: "",
        Cell: (row) => {
           if(row.row.original.user_id.id != undefined && row.row.original.user_id.id != null){ 
          const userId = row.row.original.user_id.id;
          const lastFourDigits = userId.slice(-6);
          return <p>{lastFourDigits}</p>; 
           }
        },
      },
      {
        Header: "Employee Code",
        accessor: "",
        Cell: (row) => {
          return (
            <>
              <span>
                {row.row.original.user_id.user_uid != null &&
                row.row.original.user_id.user_uid != "" ? (
                  <span>{row.row.original.user_id.user_uid}</span>
                ) : (
                  <span>{"---"} </span>
                )}
              </span>
            </>
          );
        },
      },
  
          {
      Header: "Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <span>{row.row.original.user_id.first_name}</span>
          </>
        );
      },
    },

    {
      Header: "Created date",
      accessor: "",
      Cell: (row) => {
        const dateString = row.row.original.created_at;
        const dateObject = new Date(dateString);
        const hours = dateObject.getHours();
        const minutes = dateObject.getMinutes();
        const seconds = dateObject.getSeconds();
        const amOrPm = hours >= 12 ? "PM" : "AM";
        const twelveHourFormat = hours % 12 || 12;

        const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

        const formattedTime = `${twelveHourFormat}:${formattedMinutes} ${amOrPm}`;

        return (
          <>
            <span>
              {`${
                row.row.original.created_at.slice(0, 10) + "  " + formattedTime
              }`}
            </span>
          </>
        );
      },
    },

    {
      Header: "Purpose",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <span>
              {row.row.original.purpose != null &&
              row.row.original.purpose != "" ? (
                <span>{row.row.original.purpose}</span>
              ) : (
                <span>{"---"} </span>
              )}
            </span>
          </>
        );
      },
    },

    {
      Header: "Notice Period",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <span>
              {row.row.original.emp_date != null &&
              row.row.original.emp_date != "" ? (
                <span>{row.row.original.emp_date}</span>
              ) : (
                <span>{"---"} </span>
              )}
            </span>
          </>
        );
      },
    },

    {
      Header: "Status",
      accessor: "status",
      Cell: (row) => {
        const originalString = row.row.original.status;
        const capitalizedString = capitalizeFirstLetter(originalString);
        return (
          <>
            {row.row.original.status != undefined ? (
              <>
                {row.row.original.status.toLowerCase() == "pending" ? (
                  <div className="StatusList">
                    <img src={Pendingimg} />
                    <span>{capitalizedString}</span>
                  </div>
                ) : (
                  <>
                    {row.row.original.status.toLowerCase() == "decline" ? (
                      <div className="StatusList">
                        <div className="DeclineStatus">
                          <span>x</span>
                        </div>
                        <span>{capitalizedString}</span>
                      </div>
                    ) : (
                      <>
                        {row.row.original.status.toLowerCase() == "approved" ? (
                          <div className="StatusList">
                            <img src={correctIcons} />
                            <span>{capitalizedString}</span>
                          </div>
                        ) : null}
                      </>
                    )}
                  </>
                )}
              </>
            ) : (
              <span>---</span>
            )}
          </>
        );
      },
    },

    {
      Header: "Action",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div
              class="actions"
              style={{
                display: "flex",
                justifyContent: "flex-start",
                gap: "5px",
              }}
            >
              {row.row.original.status.toLowerCase() === "approved" ? (
                <button
                  className=" btn Status"
                  component="span"
                  style={{ cursor: "not-allowed" }}
                >
                <span className="OuterActionSpan" >
                <span  className="EditImages">
                    <img src={ThumbsImage}/>
                  </span>
                    
                    <span className="ActionsList"> Approved</span>
                  </span>
                </button>
              ) : (
                <>
                  {row.row.original.status.toLowerCase() === "decline" ? (
                    <button
                      className=" btn Status"
                      component="span"
                      style={{ cursor: "not-allowed" }}
                      onClick={(e) => {
                        if (
                          !row.row.original.status.toLowerCase() == "approved"
                        ) {
                          setEmployeePop(true);
                          setEmployeeIDs(row.row.original.id);
                        }
                      }}
                    >
                                          <span className="OuterActionSpan">
                      <span  className="EditImages">
                          <img src={ThumbsImage}/>
                         </span>
                      
                      <span className="ActionsList" style={{paddingLeft:"4px",paddingTop:"2px"}}>
                                                {"Decline"}
                                                </span>

                      </span>
                    </button>
                  ) : (
                    <>
                      {row.row.original.status.toLowerCase() === "pending" ? (
                        <button
                          className=" btn Status"
                          component="span"
                          onClick={(e) => {
                            setEmployeePop(true);
                            setEmployeeIDs(row.row.original.id);
                          }}
                        >
                          {" "}
                          <span className="OuterActionSpan">
                          <span  className="EditImages">
                    <img src={EditImages}/>
                  </span>
                     <span className="ActionsList"> Approve</span>
                          </span>
                        </button>
                      ) : null}
                    </>
                  )}
                </>
              )}

            

            </div>
          </>
        );
      },
    },
  ],
  [sno]
    );
  
  const HandleSubmits = () => {
    const payload = {
      DeleteID: DeleteID,
      currentPage: currentPage,
      selectVal: selectVal,
      data: data,
      white_collar: filterForWhite.white_collar,
    };
    dispatch(SetTheResignDelete(payload, setDeletePopup(false)));
  };

  const ClearState = (Counts) => {
    if (Counts == 2) {
      dispatch(setTheResignStateStatus({value:"",label:"All"}));

      SetSelectval({
        ...selectVal,
        status: "",
      });

    }
  };

  //--------_____Filter-----------Based---On----Status--
  const count = (Counts, values, sel, SelectedValues) => {
    // console.log(Counts, values, sel, "Logs");
    // console.log(SelectedValues, "selectedvaluess");
    setSelected(sel);
    SetStates(true);
    dispatch(setTheResignStateStatus(SelectedValues));
    if (values == "Completed") {
      SetSelectval({
        ///Completed
        ...selectVal,
        status: "completed",
      });
    } else if (values == "Pending") {
      ///Pending
      SetSelectval({
        ...selectVal,
        status: "pending",
      });
    } else if (values == "Decline") {
      //Decline
      SetSelectval({
        ...selectVal,
        status: "decline",
      });
    } else if (values == "Approved") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "approved",
      });
    } else if (values == "All") {
      //Approve
      SetSelectval({
        ...selectVal,
        status: "",
      });
    }
  };
  let objectArray = [];
  //console.log(state.NumberCounts.namerednder, "names");
  options.map((item) => {
    if (item.value == 1 && state.NumberCounts.namerednder == "") {
      objectArray.push({ value: item.value, label: item.label });
    } else if (
      item.value == 1 &&
      state.NumberCounts.namerednder == "completed"
    ) {
      objectArray.push({ value: item.value, label: item.label });
    } else if (item.value == 1 && state.NumberCounts.namerednder == "Decline") {
      objectArray.push({ value: item.value, label: item.label });
    }
  });

  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h3>Resign </h3>
          </div>
        </div>

        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
               
            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col">
            <label for="validationCustom01" class="form-label">
              State 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              placeholder={"Search"}
              value={multiselect}
            />
          </div>
          <div className="col">
            <label for="validationCustom01" class="form-label">
              Region 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={true}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
            />
          </div>
          <div className="col">
            <label for="validationCustom01" class="form-label">
              Zone 
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              // options={options}
              // onChange={handleChange}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                handleZone(e);
              }}
              options={nameList4}
              isClearable={true}
              onremoved={(e) => {
                setMuliselect3(e);
                console.log(e, "jjk9090");
              }}
              value={multiselect3}
              labelledBy="Select"
              onInputChange={handleInputZone}
            />
          </div>
        </div>

        {Data != undefined ? (
          <div style={{ padding: " 0px 40px", marginTop: "-13px" }}>
            {/* <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                position: "relative",
                top: "95px",
                width: "92%",
                justifyContent: "space-around",
                alignItems: "center",
              }}
            >
              <div style={{ width: "314px" }}></div>
              <div
                class=" field-div"
                style={{
                  position: "relative",
                  top: "-16px",
                  display: "flex",
                  justifyContent: "flex-end",
                  flexDirection: "column",
                  zIndex: "1",
                  width: "351px",
                }}
              >
                <label
                  for="validationCustom02"
                  class="form-label"
                  style={{ fontSize: "15px" }}
                >
                  Employee Role
                </label>

                <Select
                  className="Selects"
                  styles={{ position: "relative", top: "60px" }}
                  onChange={(e) => {
                    HandleEMprole(e);
                  }}
                  value={EMpROleSelected}
                  options={EmpRoles}
                  placeholder="search"
                />
              </div>
            </div> */}

            <ReactTable
              data={state.resignCall.ResginDatas}
              columns={columns}
              totalItems={state.resignCall.Total_counts}
              currentPage={currentPage}
              // onPageChange={handlePageChange}
              onChange={tochange}
              setCurrentPage={setCurrentPage}
              pagesize={pagesize}
              dtpagesize={pageSize}
              dtpageindex={dtpageindex}
              pageindex={pageindex}
              datacount={state.resignCall.Total_counts}
              onPrevious={handlePrevious}
              onNextpage={handleNext}
              GotoEnteredPage={GotoEnteredPage}
              values={state.StateManagementOverallCall.ResignStatusState}
              options={options}
              Filter={Filter}
              count={count}
              ClearState={ClearState}
              placeHold={place}
              ///--- emoloyee role based filters -
              EmployeeRoleTrue={true}
              EmployeeRoleOption={EmpRoles}
              EMpROleSelected={state.StateManagementOverallCall.Resigndesignation}
              HandleEMprole={HandleEMprole}
              setsno={setsno}
              sno={sno}
              id={"spe"}
              ApproveRequestFilter={true}
       searchVal={TablePositionPersist?.ResginformlistRequestedPagelist?.search == "" || TablePositionPersist?.ResginformlistRequestedPagelist?.search ==undefined? "":TablePositionPersist.ResginformlistRequestedPagelist.search}
              search_key={true}


            />
          </div>
        ) : null}
      </div>

      {DeletePopup ? (
        <Delete
          show={DeletePopup}
          setShow={setDeletePopup}
          onSubmit={HandleSubmits}
          Content={"Do you want to delete"}
        />
      ) : null}

      {EmployeePop && EmployeeIDs != undefined ? (
        <ResignAproval
          show={EmployeeIDs}
          setShow={setEmployeePop}
          currentPage={dtpageindex}
          EditId={EmployeeIDs}
          selectVal={selectVal}
          data={data}
          white_collar={filterForWhite.white_collar}
          search_field={search}
        />
      ) : null}
    </>
  );
};

export default Resgin;
